import React, { useState, useEffect, useMemo } from 'react';
import ModalityMeasurementSelection from './ModalityMeasurementSelection';
import inputStyles from '../views/program-management/ProgramManagement.module.css';
import styles from './ManagementDropdownCard.module.css';
import toggleStyles from './CustomToggle.module.css';
import { EnrollmentDropdowns } from './EnrollmentDropdown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { initStartTime } from '../utils/programUtils';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

const PerinPatchModalityTypeSection = (props) => {
    const {
        modalityVitals,
        selectedVital,
        handleChange,
        updateStartTime,
        handleFrequency,
        handleIntervalChange,
        viewOnly,
        errorShowing,
        disabled,
        allDevices,
        modalityState,
        setModality,
        applyAllSameStartTime,
        applyAllSameFrequency,
        handleEnabledChange
    } = props;

    const data = modalityState.find((m) => m.deviceModalityId === modalityVitals[0].deviceModalityId);
    const disableInputs = useMemo(() => data.frequency === 0 || disabled, [data.frequency, disabled]);
    let [startTimeView, setStartTimeView] = useState(initStartTime(data.startTime));
    const handleStartTime = (e) => {
        let name = e.target.id;
        let value = e.target.value;
        if (name === "startInt") {
            value = Number(value);
        }
        // check if the value is between 0-24
        setStartTimeView({
            ...startTimeView,
            [name]: value
        });
        updateStartTime(name, value, startTimeView);
    };

    useEffect(() => {
        setStartTimeView(initStartTime(data.startTime))
    }, [data.startTime])

    let frequencyErrorMessage = "Please provide a valid interval: \n Day: 1-365, Min: 1-60, Hour: 1-24"
    let frequencyErrorShowing = errorShowing.showing && !data.isContinuous && (data.frequency <= 0 ||
        (data.interval === "Day" && data.frequency > 365) ||
        (data.interval === "Min" && data.frequency > 60) ||
        (data.interval === "Hour" && data.frequency > 24)
    );

    let startTimeErrorMessage = "Please provide a valid start time"
    let startTimeErrorShowing = errorShowing.showing && data.startTime === "";

    const initAllSameStartTime = () => {
        const filteredVitals = modalityState.filter(vital => vital.deviceId === 1 && vital.startTime);
        if (filteredVitals.length === 0) {
            return true;
        };
        const firstStartTime = filteredVitals[0].startTime.slice(0, 16);
        return filteredVitals.every(vital => vital.startTime.slice(0, 16) === firstStartTime);
    };

    const [allSameStartTime, setAllSameStartTime] = useState(initAllSameStartTime());

    const initAllSameFrequency = () => {
        const filteredVitals = modalityState.filter(vital => vital.deviceId === 1 && vital.frequency);
        if (filteredVitals.length === 0) {
            return true;
        };
        const firstFrequency = filteredVitals[0].frequency;
        const firstInterval = filteredVitals[0].interval;
        return filteredVitals.every(vital => (vital.frequency === firstFrequency && vital.interval === firstInterval));
    };

    const [allSameFrequency, setAllSameFrequency] = useState(initAllSameFrequency());

    useEffect(() => {
        setAllSameStartTime(initAllSameStartTime());
    }, [data.startTime]);

    useEffect(() => {
        setAllSameFrequency(initAllSameFrequency());
    }, [data.frequency, data.interval]);

    const handleApplyAllStartTime = (newStartTime) => {
        setAllSameStartTime(true);
        applyAllSameStartTime(newStartTime);
    };

    const handleApplyAllFrequency = (newFrequency, newInterval) => {
        setAllSameFrequency(true);
        applyAllSameFrequency(newFrequency, newInterval);
    };

    const createTooltip = (id, message) => (
        <Tooltip id={id}>
            {message}
        </Tooltip>
    );

    const TooltipStartTime = createTooltip("tooltip-start-time", "Apply this start time to all modalities");

    const TooltipFrequency = createTooltip("tooltip-frequency", "Apply this frequency to all modalities");


    return (
        <div style={{ display: "flex", flexDirection: "column", gap: "7px" }}>
            
            
            <div className={styles.IntervalRow}>
            <span className={styles.Interval} style={{ width: "130px" }}>Interval</span>
                <span className={styles.Interval}>Enabled</span>
                <input type="checkbox" checked={data.frequency !== 0} onChange={handleEnabledChange} />
            </div>
            <div className={styles.IntervalRow}>
                <span className={styles.Label} style={{ width: "130px" }}>
                    {`Start Time${!viewOnly ? "*" : ":"}`}
                </span>
                {viewOnly ?
                    <div>
                        {`${startTimeView.startInt} ${startTimeView.interval}`}
                    </div>
                    :
                    <>
                        <select
                            className={inputStyles.InputStyling}
                            style={(errorShowing.showing && data.startTime === "") ? { border: "1px solid red", width: "70px" } : { width: "70px" }}
                            id="startInt"
                            disabled={disableInputs}
                            value={startTimeView.startInt}
                            onChange={handleStartTime}
                        >
                            {EnrollmentDropdowns.hourIntervals.map((item, index) => (
                                <option key={index} value={item.value}>
                                    {item.label}
                                </option>
                            ))}
                        </select>
                        <select className={inputStyles.InputStyling}
                            style={(errorShowing.showing && data.startTime === "") ? { border: "1px solid red", width: "120px" } : { width: "120px" }}
                            id="interval"
                            disabled={disableInputs}
                            value={startTimeView.interval}
                            onChange={handleStartTime}
                        >
                            {EnrollmentDropdowns.timeIntervals.map((item, index) => (
                                <option key={index} value={item.value}>
                                    {item.label}
                                </option>
                            ))}
                        </select>
                        {!allSameStartTime &&
                            <button className={styles.applyAllButton} onClick={() => handleApplyAllStartTime(data.startTime)}>
                                <OverlayTrigger placement="right" overlay={TooltipStartTime}>
                                    <FontAwesomeIcon icon="fa-regular fa-clone" size="lg" />
                                </OverlayTrigger>
                            </button>
                        }
                    </>}
            </div>
            {startTimeErrorShowing &&
                <span className={inputStyles.ValidationMessage}>
                    {startTimeErrorMessage}
                </span>
            }
            <div className={styles.IntervalRow}>
                <span className={styles.Label} style={{ width: "130px" }}>
                    {`Repeat Every${!viewOnly ? "*" : ":"}`}
                </span>
                {viewOnly ?
                    <div>
                        {`${data.frequency} ${data.interval}`}
                    </div>
                    :
                    <>
                        {data.interval === "Min" ?
                            <select className={inputStyles.InputStyling}
                                style={(errorShowing.showing && frequencyErrorShowing) ? { border: "1px solid red", width: "70px" } : { width: "70px" }}
                                disabled={disableInputs}
                                id="frequency"
                                value={data.frequency}
                                onChange={(e) => {
                                    const value = parseInt(e.target.value, 10);
                                    handleFrequency({
                                        target: {
                                            value: value,
                                            id: "frequency"
                                        }
                                    });
                                }}
                            >
                                {[5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55].map((i) =>
                                    <option key={i} value={i}>
                                        {i}
                                    </option>
                                )}
                            </select>
                            :
                            <input
                                className={inputStyles.InputStyling}
                                style={(errorShowing.showing && frequencyErrorShowing) ? { border: "1px solid red", width: "70px" } : { width: "70px" }}
                                value={data.frequency}
                                id="frequency"
                                maxLength={3}
                                type="number"
                                disabled={disableInputs}
                                onChange={handleFrequency}
                            ></input>
                        }
                        <select
                            className={inputStyles.InputStyling}
                            style={(errorShowing.showing && frequencyErrorShowing) ? { border: "1px solid red", width: "120px" } : { width: "120px" }}
                            disabled={disableInputs}
                            id="interval"
                            value={data.interval}
                            onChange={handleIntervalChange}
                        >
                            {EnrollmentDropdowns.repeatIntervals.map((item, index) => (
                                <option key={index} value={item.value}>
                                    {item.label}
                                </option>
                            ))}
                        </select>
                        {!allSameFrequency &&
                            <button className={styles.applyAllButton} title="Apply to all modalities" onClick={() => handleApplyAllFrequency(data.frequency, data.interval)}>
                                <OverlayTrigger placement="right" overlay={TooltipFrequency}>
                                    <FontAwesomeIcon icon="fa-regular fa-clone" size="lg" />
                                </OverlayTrigger>
                            </button>
                        }
                    </>
                }
            </div>
            {frequencyErrorShowing &&
                <span className={inputStyles.ValidationMessage}>
                    {frequencyErrorMessage}
                </span>
            }
            <div style={{ width: "auto" }}>
                <div className={toggleStyles.Toggle}>
                    {modalityVitals.map((vital) => {
                        const showErrors = errorShowing?.modalityErrors?.some(id => id === vital.deviceModalityId) || false;
                        return (<React.Fragment key={vital.deviceModalityId}>
                            <input
                                type="radio"
                                name="customToggle"
                                value={vital.deviceModalityId}
                                checked={selectedVital.deviceModalityId === vital.deviceModalityId}
                                onChange={() => handleChange(vital)}
                            ></input>
                            <label
                                style={{ color: showErrors ? 'rgb(220, 53, 69)' : 'inherit' }}
                                onClick={() => handleChange(vital)}
                            > {vital.modalityName}</label>
                        </React.Fragment>)
                    })}
                </div>
            </div>
            <div>
                {modalityVitals.map((item, index) => (
                    <div key={index} hidden={item.deviceModalityId === selectedVital.deviceModalityId ? false : true}>
                        <ModalityMeasurementSelection
                            deviceId={1} //perin patch id
                            deviceModalityId={item.deviceModalityId}
                            setModality={setModality}
                            dataList={modalityState}
                            disabled={disableInputs || viewOnly}
                            errors={errorShowing}
                            allDevices={allDevices}
                            isPerinPatch={true}
                        />
                    </div>
                ))}
            </div>
            {errorShowing.modalityShowing && errorShowing.deviceIdErrors.some(item => item === 1) &&
                <div className={inputStyles.ValidationMessageContainer}>
                    <FontAwesomeIcon icon="fa-solid fa-triangle-exclamation" size="xs" style={{ color: "red" }} />
                    <span className={inputStyles.ValidationMessage}>
                        {errorShowing.modalityMessage}
                    </span>
                </div>
            }
            <div style={{ padding: "1px" }}></div>
        </div>
    )
}

export default PerinPatchModalityTypeSection;